import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import '../Pesquisar.css';
import { Button, Modal, Spin, Tag } from 'antd';
import { useConfigQuery } from '../../../../queries/useConfig';
import IdentificarConsumidor from '../FinalizarVenda/IdentificarConsumidor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import FormClientes from './FormClientes';
import FormularioDeProdutos from './FormularioDeProdutos';
import { Select } from 'antd/lib';
import { Option } from 'antd/es/mentions';
import { api } from '../../../../config/api';



const GerenciarProdutos = ({ closeModal }) => {
  // validarEstoque da prop é para telas que não necessite de validação usarem como false

  const [tipoBusca, setTipoBusca] = useState('padrao');

  const endpointPorTipo = {
    padrao: `${api.techspdv}/v1/restaurantes`,
    categoria: `${api.techspdv}/v1/restaurantes`,
    ean: `${api.techspdv}/v1/restaurantes`,
    codigo: `${api.techspdv}/v1/restaurantes`,
    unidade: `${api.techspdv}/v1/restaurantes`,
    valor: `${api.techspdv}/v1/restaurantes`,
    estoque: `${api.techspdv}/v1/restaurantes`,
    ncmcest: `${api.techspdv}/v1/restaurantes`
  };

  const dispatch = useDispatch();
  const { data: config, error } = useConfigQuery();
  const [searchTerm, setSearchTerm] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [produtos, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const [restauranteId, setRestauranteId] = useState('');
  // currentPage representa a próxima página a ser carregada
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loja, setLoja] = useState({});

  // Refs para o container de scroll e para o elemento trigger
  const containerRef = useRef(null);
  const targetRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [produto, setProduto] = useState(null);

  const handleSavedProduto = (updated) => {
    setProducts(prev =>
      prev.map(c => (c.id === updated.id ? { ...c, ...updated } : c))
    );
    setProduto(updated);        // mantém o selecionado sincronizado
    //setIsModalVisible(false);
  };

  const handleOpenModal = (item) => {
    if (item?.categoria) {
      console.log(item);
      item.idCategoria = item.categoria.id;
      setProduto(item);
    }

    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setProduto(null);
    setProducts([]);
    loadProducts();
  };

  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };
      axios
        .get(`${api.techfood}/v1/restaurantes/usuario/${idUser}`, options)
        .then(response => {
          setRestauranteId(response.data.id);
          setLoja(response.data);
          console.log(response.data);
        })
        .catch(error => console.error('Erro ao buscar restaurante:', error));
    }
  }, [idUser, accessToken]);

  const handleItemPress = item => {
    console.log(item);
    handleOpenModal(item);
  };


  const loadProducts = useCallback(
    async (pageToLoad) => {
      if (!accessToken || !restauranteId || (!searchTerm && config?.terminalComercial?.pesquisaLivre == false)) return;
      if (pageToLoad >= totalPages) return;

      setIsLoading(true);
      try {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        };

        // ✅ escolhe o endpoint conforme o combo
        const endpointPorTipo = {
          padrao: 'eancodnome',
          categoria: 'buscarPor/categoria',
          ean: 'buscarPor/ean',
          codigo: 'buscarPor/codigo',
          unidade: 'buscarPor/unidade',
          valor: 'buscarPor/valor',
          estoque: 'buscarPor/estoque',
          nome: 'buscarPor/nome',
          ncmcest: 'buscarPor/ncmcest'
        };

        const endpoint = endpointPorTipo[tipoBusca] || 'eancodnome';

        const url = `${api.techspdv}/v1/restaurantes/${restauranteId}/produtos/${endpoint}?page=${pageToLoad}`;

        // ✅ mantém seu payload atual
        const payload = { texto: searchTerm || '' };

        const response = await axios.post(url, payload, options);

        const produtos = response.data._embedded?.produtos || [];
        const { number, totalPages: total } = response.data.page;
        setTotalPages(total);

        if (pageToLoad === 0) {
          setProducts(produtos);
        } else {
          setProducts(prev => [...prev, ...produtos]);
        }

        setCurrentPage(number + 1);
      } catch (error) {
        console.error('Erro ao carregar produtos:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [accessToken, restauranteId, searchTerm, totalPages, tipoBusca, config?.terminalComercial?.pesquisaLivre]
  );

  // Acionado ao clicar no botão "Pesquisar"
  const handleSearch = () => {
    // Reinicia os estados para nova pesquisa
    setProducts([]);
    setCurrentPage(0);
    setTotalPages(1);
    setHasSearched(true);
    loadProducts(0);
  };

  // Intersection Observer para carregar páginas extras quando o fim do container for alcançado
  useEffect(() => {
    // Só ativa se já houve uma pesquisa
    if (!hasSearched || !containerRef.current) return;

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && !isLoading && currentPage < totalPages) {
          loadProducts(currentPage);
        }
      },
      { root: containerRef.current, threshold: 0.1 }
    );

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [hasSearched, isLoading, currentPage, totalPages, loadProducts]);

  const formatarTelefone = (phoneNumber) => {
    const cleaned = phoneNumber.replace(/\D/g, '');
    if (cleaned.startsWith('55') && (cleaned.length === 12 || cleaned.length === 13)) {
      const numberWithoutCountryCode = cleaned.substring(2);
      if (numberWithoutCountryCode.length === 11) {
        return numberWithoutCountryCode.replace(/^(\d{2})(\d{5})(\d{4})$/, '+55 ($1) $2-$3');
      } else if (numberWithoutCountryCode.length === 10) {
        return numberWithoutCountryCode.replace(/^(\d{2})(\d{4})(\d{4})$/, '+55 ($1) $2-$3');
      } else {
        return phoneNumber;
      }
    } else {
      return phoneNumber;
    }
  };
  function formatarCpfCnpj(cpfCnpj) {
    cpfCnpj = cpfCnpj.replace(/\D/g, '');

    if (cpfCnpj.length === 11) {
      return cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (cpfCnpj.length === 14) {
      return cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    } else {
      return cpfCnpj;
    }
  }


  const renderItem = item => {
    const formattedPrice = item.preco.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    return (
      <div
        className="card"
        onClick={() => { handleItemPress(item) }}
        //onClick={() => {console.log((config?.terminalComercial?.gerenciaEstoque && parseFloat(item.quantidade_estoque) > 0) || (config?.terminalComercial?.gerenciaEstoque == false ||  config?.terminalComercial?.venderZerado));}}

        style={{ position: 'relative' }}
      >
        <span className="card-text">{item.nome}</span>
        {item.temMkt && (
          <Tag color="blue" style={{ marginLeft: 8 }}>
            Market Place
          </Tag>
        )}
        <br />
        <span className="card-text-ean"><strong>GTIN:</strong> {`${item.ean} | `}</span>
        <span className="card-text-ean"><strong> Código:</strong> {`${item.codigo} | `} </span>
        <span className="card-text-ean"><strong> Sku:</strong> {`${item.sku} | `} | </span>
        <span className="card-text-ean"><strong> NCM:</strong> {`${item.ncm}`}</span>
        <br />
        <span className="card-text">{formattedPrice}</span>

        <span
          className="card-text-ean"
          style={{
            position: 'absolute',
            right: '10px',
            top: '5%',
          }}
        >
          {item.categoria.nome}
        </span>

        {config?.terminalComercial?.gerenciaEstoque == '1' && (
          <span
            className="card-text"
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)'
            }}
          >
            Qtd: {parseFloat(item.quantidade_estoque)}
          </span>
        )}


      </div>
    );
  };
  return (
    <div className="container-pesquisar">
      <div className="modal-header">
        <Button
          type="primary"
          onClick={() => handleOpenModal(true)}
          style={{ backgroundColor: "black", borderColor: "black" }}
        >
          <span>Novo</span>
        </Button>
        <h2>Produtos</h2>

      </div>

      <div className="search-container">
        <input
          className="input"
          type="text"
          placeholder="Pesquisar por EAN, Nome ou Código Interno"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
        <Select
          value={tipoBusca}
          style={{ width: 220, marginRight: 8 }}
          onChange={(v) => {
            setTipoBusca(v);
          }}
        >
          <Option value="padrao">Padrão</Option>
          <Option value="nome">Nome</Option>
          <Option value="categoria">Categoria</Option>
          <Option value="ean">Ean</Option>
          <Option value="ncmcest">NCM / CEST</Option>
          <Option value="codigo">Código de Integração</Option>
          <Option value="unidade">Unidade</Option>
          <Option value="valor">Valor</Option>
          <Option value="estoque">Estoque</Option>
        </Select>

        <button
          className="search-button"
          disabled={!accessToken || !restauranteId || (!searchTerm && config?.terminalComercial?.pesquisaLivre == false)}
          onClick={handleSearch}
        >
          Pesquisar
        </button>
      </div>

      {isLoading && produtos.length === 0 ? (
        <Spin
          spinning={isLoading}
          tip={<span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>Carregando...</span>}
          size="large"
        />

      ) : (
        <div className="scroll-container" ref={containerRef}>
          <div className="product-list">
            {produtos.length > 0 ? (
              produtos.map(produto => (
                <React.Fragment key={produto.id}>{renderItem(produto)}</React.Fragment>
              ))
            ) : (
              <p className="empty-list-text">Nenhum produto encontrado</p>
            )}
          </div>
          {isLoading && <div className="loading">Carregando...</div>}
          {/* Elemento trigger para o Intersection Observer */}
          <div ref={targetRef} id="scroll-end" style={{ height: '10px' }}></div>
        </div>
      )}



      <Modal
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        width="100vw"
        bodyStyle={{ padding: 0 }}
        centered
        closeIcon={null} // Remove o ícone de fechamento padrão
        destroyOnClose={true}
      >

        <Button
          type="primary"
          onClick={handleCloseModal}
          style={{ backgroundColor: "black", borderColor: "black" }}
        >
          <span>Abandonar <FontAwesomeIcon icon={faSignOutAlt} /></span>
        </Button>

        <FormularioDeProdutos onClose={handleCloseModal} onSaved={handleSavedProduto} produto={produto} setProduto={setProduto} produtos={produtos} setProducts={setProducts}></FormularioDeProdutos>
      </Modal>
    </div>
  );
};

export default GerenciarProdutos;
